// extracted by mini-css-extract-plugin
module.exports = {"date":"AuctionActivityDateHeadline_date__3MSCC"};